var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailableLenderOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.92005V47.0801C1 49.2401 2.75 51.0001 4.91 51.0001H38.74C40.9 51.0001 42.65 49.2501 42.65 47.0901V4.92005C42.65 2.76005 40.9 1.01005 38.74 1.01005H4.91C2.75 1.00005 1 2.76005 1 4.92005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.12V46.87C1 49.15 2.84 51 5.12 51H38.54C40.81 51 42.66 49.16 42.66 46.88V5.12C42.66 2.85 40.82 1 38.54 1H5.12C2.84 1 1 2.85 1 5.12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40859 10.72C9.43032 10.72 10.2586 9.89175 10.2586 8.87002C10.2586 7.84829 9.43032 7.02002 8.40859 7.02002C7.38687 7.02002 6.55859 7.84829 6.55859 8.87002C6.55859 9.89175 7.38687 10.72 8.40859 10.72Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 8.87012H36.2714",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40859 19.0599C9.43032 19.0599 10.2586 18.2316 10.2586 17.2099C10.2586 16.1881 9.43032 15.3599 8.40859 15.3599C7.38687 15.3599 6.55859 16.1881 6.55859 17.2099C6.55859 18.2316 7.38687 19.0599 8.40859 19.0599Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 17.21H36.2714",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40859 27.3899C9.43032 27.3899 10.2586 26.5617 10.2586 25.5399C10.2586 24.5182 9.43032 23.6899 8.40859 23.6899C7.38687 23.6899 6.55859 24.5182 6.55859 25.5399C6.55859 26.5617 7.38687 27.3899 8.40859 27.3899Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 25.54H36.2714",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8703 26.78L30.6803 46.97C30.5003 47.15 30.2103 47.15 30.0403 46.97L18.5803 35.51C18.4003 35.33 18.4003 35.05 18.5803 34.87L21.3603 32.09C21.5403 31.91 21.8303 31.91 22.0003 32.09L30.3503 40.44L47.4303 23.36C47.6103 23.18 47.9003 23.18 48.0703 23.36L50.8503 26.14C51.0403 26.32 51.0403 26.61 50.8703 26.78Z",
    fill: "#FFCF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8703 26.78L30.6803 46.97C30.5003 47.15 30.2103 47.15 30.0403 46.97L18.5803 35.51C18.4003 35.33 18.4003 35.05 18.5803 34.87L21.3603 32.09C21.5403 31.91 21.8303 31.91 22.0003 32.09L30.3503 40.44L47.4303 23.36C47.6103 23.18 47.9003 23.18 48.0703 23.36L50.8503 26.14C51.0403 26.32 51.0403 26.61 50.8703 26.78Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableLenderOptions);
export default __webpack_public_path__ + "static/media/AvailableLenderOptions.b8e9607374d48669f829f813925efe3f.svg";
export { ForwardRef as ReactComponent };